// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-40[data-v-5ccf0aa8]{width:40%}.w-60[data-v-5ccf0aa8]{width:60%}", ""]);
// Exports
module.exports = exports;
